/* ============================================================
 * Brindle UK · PDP (Sales page) — page script
 * Loaded conditionally from layout/theme.liquid only on
 * template.name == 'product' AND template.suffix == 'brindle'.
 * Reads PRODUCT JSON injected by Liquid as window.__brindlePdpProduct.
 * ============================================================ */
(function () {
  'use strict';
  if (window.__brindlePdpLoaded) return;
  window.__brindlePdpLoaded = true;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    var n = (cents || 0) / 100;
    // Strip trailing .00 — UK style £39 instead of £39.00
    if (n === Math.floor(n)) return '£' + n;
    return '£' + n.toFixed(2);
  }

  function init() {
    var root = $('.bpdp-scope');
    if (!root) return;
    var product = window.__brindlePdpProduct;
    if (!product) return;

    var state = {
      pack:  null,
      color: null,
      size:  null,
      variant: null,
      patchEnabled: false
    };

    // Detect option positions (Shopify is 1-based: option1, option2, option3)
    var optMap = {};
    (product.options || []).forEach(function (name, idx) {
      optMap[name.toLowerCase()] = idx; // 0/1/2
    });
    var packIdx  = optMap.pack;
    var colorIdx = optMap.color;
    var sizeIdx  = optMap.size;

    function variantOption(v, idx) {
      return v && v.options ? v.options[idx] : null;
    }

    // Resolve current variant by selected pack/color/size
    function resolveVariant() {
      if (!product.variants) return null;
      return product.variants.find(function (v) {
        if (state.pack  && variantOption(v, packIdx)  !== state.pack)  return false;
        if (state.color && variantOption(v, colorIdx) !== state.color) return false;
        if (state.size  && variantOption(v, sizeIdx)  !== state.size)  return false;
        return true;
      }) || null;
    }

    // Available combos (used to grey-out impossible selections)
    function isComboAvailable(pack, color, size) {
      return product.variants.some(function (v) {
        if (!v.available) return false;
        if (pack  && variantOption(v, packIdx)  !== pack)  return false;
        if (color && variantOption(v, colorIdx) !== color) return false;
        if (size  && variantOption(v, sizeIdx)  !== size)  return false;
        return true;
      });
    }

    function updateButtonsAvailability() {
      // Color: greyed if no available variant for current pack+size
      $$('.bpdp-color__swatch').forEach(function (sw) {
        var c = sw.dataset.color;
        var ok = isComboAvailable(state.pack, c, state.size);
        sw.classList.toggle('is-unavailable', !ok);
      });
      // Size: greyed if no available variant for current pack+color
      $$('.bpdp-size__btn').forEach(function (b) {
        var s = b.dataset.size;
        var ok = isComboAvailable(state.pack, state.color, s);
        b.classList.toggle('is-unavailable', !ok);
      });
      // Pack cards: usually all packs are available — disable only if entire pack has 0 stock
      $$('.bpdp-pack__card').forEach(function (c) {
        var p = c.dataset.pack;
        var ok = isComboAvailable(p, state.color, state.size);
        c.classList.toggle('is-unavailable', !ok);
      });
    }

    function updatePriceUI() {
      var v = state.variant;
      var current  = $('[data-bpdp-price-current]');
      var anchor   = $('[data-bpdp-price-anchor]');
      var discount = $('[data-bpdp-price-discount]');
      var atcPrice = $('[data-bpdp-atc-price]');
      var stickyPx = $('[data-bpdp-sticky-price]');
      var atcBtn   = $('[data-bpdp-atc]');

      if (!v) {
        if (current) current.textContent = '—';
        if (anchor) anchor.textContent = '';
        if (discount) discount.style.display = 'none';
        if (atcBtn) {
          atcBtn.disabled = true;
          var atcLabelNo = $('[data-bpdp-atc-label]', atcBtn);
          var atcPriceNo = $('[data-bpdp-atc-price]', atcBtn);
          if (atcLabelNo) atcLabelNo.textContent = 'Choose options';
          if (atcPriceNo) atcPriceNo.textContent = '';
        }
        return;
      }

      if (current) current.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (anchor) anchor.textContent = money(v.compare_at_price);
        if (discount) {
          discount.textContent = 'SAVE ' + money(v.compare_at_price - v.price);
          discount.style.display = '';
        }
      } else {
        if (anchor) anchor.textContent = '';
        if (discount) discount.style.display = 'none';
      }
      // If the addon is active (checkbox on, pack matches), reflect +£X in the displayed total
      var addonCfg = window.__brindlePdpAddon || {};
      var effectivePrice = v.price;
      if (addonIsActive() && addonCfg.cents) effectivePrice = v.price + parseInt(addonCfg.cents, 10);
      if (atcPrice) atcPrice.textContent = '· ' + money(effectivePrice);
      if (stickyPx) stickyPx.textContent = money(effectivePrice);
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        var atcLabel = $('[data-bpdp-atc-label]', atcBtn);
        if (atcLabel) {
          if (!v.available) atcLabel.textContent = 'Sold out';
          // For available variants we DO NOT overwrite the label — Liquid already set
          // the customized atc_label text. Overwriting would clobber it on re-render.
        }
      }
    }

    function updatePackPricesUI() {
      // For each pack option value, find the variant matching the CURRENT color+size+that pack.
      // Fill its price + save amount in the pack card.
      if (packIdx == null) return;
      var packCards = $$('.bpdp-pack__card');
      packCards.forEach(function (card) {
        var pv = card.dataset.pack;
        if (!pv) return;
        // Try exact match with current color+size first
        var match = product.variants.find(function (v) {
          if (variantOption(v, packIdx) !== pv) return false;
          if (colorIdx != null && state.color && variantOption(v, colorIdx) !== state.color) return false;
          if (sizeIdx  != null && state.size  && variantOption(v, sizeIdx)  !== state.size)  return false;
          return true;
        });
        // Fallback: any variant with this pack (e.g. when color/size unavailable for pack)
        if (!match) {
          match = product.variants.find(function (v) {
            if (variantOption(v, packIdx) !== pv) return false;
            if (sizeIdx != null && state.size && variantOption(v, sizeIdx) !== state.size) return false;
            return true;
          });
        }
        if (!match) {
          match = product.variants.find(function (v) {
            return variantOption(v, packIdx) === pv;
          });
        }
        var priceEl = card.querySelector('[data-bpdp-pack-price]');
        var saveEl  = card.querySelector('[data-bpdp-pack-save]');
        if (priceEl) priceEl.textContent = match ? money(match.price) : '';
        if (saveEl) {
          if (match && match.compare_at_price && match.compare_at_price > match.price) {
            saveEl.textContent = 'Save ' + money(match.compare_at_price - match.price);
            saveEl.style.visibility = 'visible';
          } else {
            saveEl.textContent = '';
            saveEl.style.visibility = 'hidden';
          }
        }
      });
    }

    function updateImageForColor() {
      // Switch the main gallery image to match the selected color, if a variant
      // with that color has a featured_media set.
      var v = state.variant;
      if (!v || v.featured_image == null) return;
      var src = v.featured_image.src || v.featured_image;
      var img = $('[data-bpdp-main-img]');
      if (img && typeof src === 'string') {
        img.src = src;
      }
    }

    function updatePatchUI() {
      var status = $('[data-bpdp-patch-status]');
      var toggle = $('[data-bpdp-patch-toggle]');
      var inputSingle = $('[data-bpdp-patch-input="single"]');
      var inputDual   = $('[data-bpdp-patch-input="dual"]');
      var checkbox = $('[data-bpdp-patch-checkbox]');

      // Helpers to clear hidden input values so they don't leak to the cart
      function clearSingle() {
        if (!inputSingle) return;
        var inp = inputSingle.querySelector('input[type="text"]');
        if (inp) inp.value = '';
      }
      function clearDual() {
        if (!inputDual) return;
        $$('input[type="text"]', inputDual).forEach(function (i) { i.value = ''; });
      }

      // Identify pack by lowercased name match
      var packName = (state.pack || '').toLowerCase();
      var isPack1 = packName.indexOf('walkies') !== -1 || packName === 'pack 1';
      var isPack3 = packName.indexOf('family') !== -1 || packName === 'pack 3';

      if (isPack1) {
        // ADD-ON mode: red badge + add-on card with checkbox + price.
        var addonCents = (window.__brindlePdpAddon && window.__brindlePdpAddon.cents) || 1000;
        var addonLabel = '£' + (addonCents / 100).toFixed(addonCents % 100 ? 2 : 0).replace(/\.00$/, '');
        if (status) {
          status.textContent = 'ADD-ON +' + addonLabel;
          status.classList.add('is-optional');
          status.classList.add('is-addon');
        }
        if (toggle) toggle.style.display = 'flex';
        if (inputSingle) inputSingle.classList.toggle('is-shown', !!(checkbox && checkbox.checked));
        if (inputDual) inputDual.classList.remove('is-shown');
        // Dual is irrelevant here — always clear its values
        clearDual();
        // If user unchecks the add-on box → also clear the single
        if (checkbox && !checkbox.checked) clearSingle();
      } else if (isPack3) {
        if (status) {
          status.textContent = '✓ 2× INCLUDED IN YOUR PACK';
          status.classList.remove('is-optional');
          status.classList.remove('is-addon');
        }
        if (toggle) toggle.style.display = 'none';
        if (inputSingle) inputSingle.classList.remove('is-shown');
        if (inputDual) inputDual.classList.add('is-shown');
        if (checkbox) checkbox.checked = false;
        // Single is irrelevant here — clear it so the Best Mate name doesn't leak
        clearSingle();
      } else {
        if (status) {
          status.textContent = '✓ INCLUDED IN YOUR KIT';
          status.classList.remove('is-optional');
          status.classList.remove('is-addon');
        }
        if (toggle) toggle.style.display = 'none';
        if (inputSingle) inputSingle.classList.add('is-shown');
        if (inputDual) inputDual.classList.remove('is-shown');
        if (checkbox) checkbox.checked = false;
        // Dual is irrelevant here — clear the Family Pack names so they don't leak
        clearDual();
      }
    }

    function updateSelectedNames() {
      var cn = $('[data-bpdp-color-name]');
      var sn = $('[data-bpdp-size-name]');
      if (cn) cn.textContent = state.color || '';
      if (sn) sn.textContent = state.size || '';
    }

    function recompute() {
      state.variant = resolveVariant();
      updatePriceUI();
      updatePackPricesUI();
      updateImageForColor();
      updatePatchUI();
      updateSelectedNames();
      updateButtonsAvailability();
      // Hidden form variant id for the ATC submission
      var idInput = $('[data-bpdp-variant-id]');
      if (idInput) idInput.value = state.variant ? state.variant.id : '';
    }

    /* ---------- Bind selectors ---------- */

    // Pack
    $$('.bpdp-pack__card').forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('is-unavailable')) return;
        state.pack = card.dataset.pack;
        $$('.bpdp-pack__card').forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        recompute();
      });
    });

    // Color
    $$('.bpdp-color__swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.classList.contains('is-unavailable')) return;
        state.color = sw.dataset.color;
        $$('.bpdp-color__swatch').forEach(function (s) { s.classList.toggle('is-selected', s === sw); });
        recompute();
      });
    });

    // Size
    $$('.bpdp-size__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-unavailable')) return;
        state.size = b.dataset.size;
        $$('.bpdp-size__btn').forEach(function (x) { x.classList.toggle('is-selected', x === b); });
        recompute();
      });
    });

    // Name patch checkbox (Pack 1 only) — also recompute price total
    var patchCheckbox = $('[data-bpdp-patch-checkbox]');
    if (patchCheckbox) {
      patchCheckbox.addEventListener('change', function () {
        state.patchEnabled = patchCheckbox.checked;
        updatePatchUI();
        updatePriceUI();
      });
    }
    // Also recompute on typing into single name input (in case price tracking needed)
    var singleInp = $('[data-bpdp-patch-input="single"] input[type="text"]');
    if (singleInp) {
      singleInp.addEventListener('input', function () { updatePriceUI(); });
    }
    // Force ALL name patch inputs (single + dual Dog 1/Dog 2) to UPPERCASE on input.
    // The CSS already shows uppercase via text-transform; this also coerces the
    // submitted form value so the merchant receives uppercase strings.
    $$('.bpdp-patch input[type="text"]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var caret = inp.selectionStart;
        var up = (inp.value || '').toUpperCase();
        if (inp.value !== up) {
          inp.value = up;
          // restore caret so the user doesn't jump to end mid-typing
          try { inp.setSelectionRange(caret, caret); } catch (_) {}
        }
      });
    });

    /* ---------- Initial state — prefer Black available variant, then selected/first ---------- */
    function pickInitialVariant() {
      // Prefer a Black available variant if color option exists
      if (colorIdx != null && product.variants) {
        var blackRe = /^\s*(black|negro|noir|schwarz|nero)\s*$/i;
        var blackV = product.variants.find(function (v) {
          if (!v.available) return false;
          var c = variantOption(v, colorIdx);
          return c && blackRe.test(c);
        });
        if (blackV) return blackV;
      }
      return product.selected_or_first_available_variant || product.variants[0];
    }
    var initial = pickInitialVariant();
    if (initial) {
      state.pack  = packIdx  != null ? variantOption(initial, packIdx)  : null;
      state.color = colorIdx != null ? variantOption(initial, colorIdx) : null;
      state.size  = sizeIdx  != null ? variantOption(initial, sizeIdx)  : null;
      // Mark UI as selected to match
      $$('.bpdp-pack__card').forEach(function (c) { c.classList.toggle('is-selected', c.dataset.pack === state.pack); });
      $$('.bpdp-color__swatch').forEach(function (s) { s.classList.toggle('is-selected', s.dataset.color === state.color); });
      $$('.bpdp-size__btn').forEach(function (b) { b.classList.toggle('is-selected', b.dataset.size === state.size); });
    }
    recompute();

    /* ---------- Addon detection ---------- */
    // addonIsActive: pack matches + checkbox checked. Used for PRICE display.
    function addonIsActive() {
      var cfg = window.__brindlePdpAddon || {};
      if (!cfg.variantId) return false;
      var packMatch = String(cfg.packMatch || 'Walkies Ready').toLowerCase();
      var packName = (state.pack || '').toLowerCase();
      if (packName.indexOf(packMatch) === -1 && packMatch.indexOf(packName) === -1) return false;
      var checkbox = $('[data-bpdp-patch-checkbox]');
      return !!(checkbox && checkbox.checked);
    }
    // addonShouldFire: addonIsActive AND a name typed.
    // Without a name there's nothing to embroider — skip the add-on charge.
    function addonShouldFire() {
      if (!addonIsActive()) return false;
      var input = $('[data-bpdp-patch-input="single"] input[type="text"]');
      var nm = input && input.value && input.value.trim();
      return !!nm;
    }

    function getPatchName() {
      var input = $('[data-bpdp-patch-input="single"] input[type="text"]');
      return input && input.value ? input.value.trim() : '';
    }

    function getDualPatchNames() {
      var dual = $('[data-bpdp-patch-input="dual"]');
      if (!dual) return null;
      var inputs = $$('input[type="text"]', dual);
      var a = inputs[0] && inputs[0].value && inputs[0].value.trim();
      var b = inputs[1] && inputs[1].value && inputs[1].value.trim();
      return { a: a || '', b: b || '' };
    }

    /* ---------- ATC: AJAX cart submit + open theme drawer (no redirect) ---------- */
    function openCartDrawer() {
      // Try every known event/selector the theme might use
      var events = ['cart:open','cart:added','cart:refresh','cart:updated','cart-update','on:cart-update','drawer:open'];
      events.forEach(function (n) {
        try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
        try { window.dispatchEvent(new CustomEvent(n)); } catch (e) {}
      });
      // Dawn-style PubSub
      try { if (window.publish) window.publish('cart-update', {}); } catch (e) {}
      // Click any drawer trigger as last resort
      var triggers = document.querySelectorAll('[data-cart-drawer-trigger], .cart-icon-bubble, .header__cart-link, cart-drawer-icon, [data-action="open-cart"]');
      if (triggers.length) { try { triggers[0].click(); } catch (e) {} }
    }
    function refreshCartCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-bra-cart-count],[data-bpdp-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          $$('[data-bra-cart-link],[data-bpdp-cart-link]').forEach(function (el) {
            el.classList.add('is-cart-pulse');
            setTimeout(function () { el.classList.remove('is-cart-pulse'); }, 400);
          });
        })
        .catch(function () {});
    }
    var form = $('[data-bpdp-form]');
    var atcButton = $('[data-bpdp-atc]');

    function performSubmit(e) {
      if (e) {
        e.preventDefault();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        e.stopPropagation();
      }
      if (!state.variant || !state.variant.available) {
        try { console.warn('[Brindle] submit aborted — no variant or unavailable'); } catch(_) {}
        return false;
      }
      var atcBtn = $('[data-bpdp-atc]');
      if (atcBtn) atcBtn.disabled = true;

      var addonFires = addonShouldFire();
      try {
        console.log('[Brindle] submit. addonFires=', addonFires,
          'addonIsActive=', addonIsActive(),
          'state.pack=', state.pack,
          'addonCfg=', window.__brindlePdpAddon,
          'checkbox=', $('[data-bpdp-patch-checkbox]') && $('[data-bpdp-patch-checkbox]').checked
        );
      } catch(_) {}
      var done = function (ok) {
        if (atcBtn) atcBtn.disabled = false;
        if (!ok) return;
        refreshCartCount();
        openCartDrawer();
      };

      if (addonFires) {
        var nm = getPatchName();
        var addonCfg = window.__brindlePdpAddon || {};
        // Harness goes WITHOUT a Name patch property when the patch is a paid
        // add-on (so it doesn't appear duplicated on both lines in the cart).
        // The add-on line carries the embroidery name.
        var harnessProps = {};
        var addonProps = { 'Name patch': nm };
        var addonIdStr = String(addonCfg.variantId || '');
        var addonId = Number(addonIdStr) || addonIdStr;
        var items = [
          { id: state.variant.id, quantity: 1, properties: harnessProps },
          { id: addonId, quantity: 1, properties: addonProps }
        ];
        try { console.log('[Brindle] POST /cart/add.js items=', items); } catch(_) {}
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            try { console.log('[Brindle] cart response', res); } catch(_) {}
            done(res.ok);
          })
          .catch(function (err) { try { console.error('[Brindle] cart error', err); } catch(_) {} done(false); });
      } else {
        var fd = form ? new FormData(form) : new FormData();
        var propKeys = [];
        fd.forEach(function (val, key) {
          if (/^properties\[/.test(key) && String(val).trim() === '') propKeys.push(key);
        });
        propKeys.forEach(function (k) { fd.delete(k); });
        // If this pack treats the patch as a paid add-on (Walkies Ready) but the
        // user didn't trigger the add-on (no checkbox or no name), the harness
        // should NOT carry a 'Name patch' property — that property only belongs
        // on the separate add-on line.
        if (addonIsActive() || (function(){
          var cfg = window.__brindlePdpAddon || {};
          if (!cfg.variantId) return false;
          var packMatch = String(cfg.packMatch || 'Walkies Ready').toLowerCase();
          var packName = (state.pack || '').toLowerCase();
          return packName.indexOf(packMatch) !== -1 || packMatch.indexOf(packName) !== -1;
        })()) {
          fd.delete('properties[Name patch]');
        }
        try { console.log('[Brindle] POST /cart/add.js FormData (single item)'); } catch(_) {}
        fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/javascript' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) { done(res.ok); })
          .catch(function () { done(false); });
      }
      return false;
    }

    // Hook the ATC button CLICK in capture phase so we run BEFORE any theme listener
    if (atcButton) {
      atcButton.addEventListener('click', performSubmit, { capture: true });
    }
    // Belt-and-braces: also catch the form submit event in capture phase
    if (form) {
      form.addEventListener('submit', performSubmit, { capture: true });
    }

    /* ---------- Gallery — slider + thumbs ---------- */
    var slider = $('[data-bpdp-gallery-slider]');
    var slides = $$('.bpdp-gallery__slide');
    var mainImg = $('[data-bpdp-main-img]');
    var thumbs = $$('.bpdp-gallery__thumb');
    var thumbsContainer = $('.bpdp-gallery__thumbs');

    function syncThumbScroll(t) {
      // Horizontal-only scroll to center the active thumb. NEVER scrollIntoView.
      if (!t || !thumbsContainer) return;
      var crect = thumbsContainer.getBoundingClientRect();
      var trect = t.getBoundingClientRect();
      var delta = (trect.left + trect.width / 2) - (crect.left + crect.width / 2);
      thumbsContainer.scrollTo({ left: thumbsContainer.scrollLeft + delta, behavior: 'smooth' });
    }

    function scrollSliderToIndex(idx) {
      if (!slider || !slides.length) return;
      var s = slides[idx];
      if (!s) return;
      slider.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
    }

    function selectThumb(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      // On mobile (slider is scrollable) → scroll to the matching slide
      if (slider) scrollSliderToIndex(idx);
      // On desktop where slider isn't scrollable, also swap the first slide's src
      if (mainImg && thumbs[idx] && thumbs[idx].dataset.fullSrc) {
        mainImg.src = thumbs[idx].dataset.fullSrc;
      }
      syncThumbScroll(thumbs[idx]);
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectThumb(i); });
    });

    // Arrows (desktop) — prev/next navigate the slider + active thumb
    function currentSlideIdx() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('is-active')) return i;
      return 0;
    }
    var arrowPrev = $('.bpdp-gallery__arrow--prev');
    var arrowNext = $('.bpdp-gallery__arrow--next');
    if (arrowPrev) {
      arrowPrev.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = currentSlideIdx() - 1;
        if (idx < 0) idx = (thumbs.length || slides.length) - 1;
        selectThumb(idx);
      });
    }
    if (arrowNext) {
      arrowNext.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = currentSlideIdx() + 1;
        var max = (thumbs.length || slides.length);
        if (idx >= max) idx = 0;
        selectThumb(idx);
      });
    }

    // When the user swipes the slider on mobile, update the active thumb
    if (slider) {
      var swipeTimer = null;
      slider.addEventListener('scroll', function () {
        clearTimeout(swipeTimer);
        swipeTimer = setTimeout(function () {
          var sliderRect = slider.getBoundingClientRect();
          var centerX = sliderRect.left + sliderRect.width / 2;
          var bestIdx = 0;
          var bestDist = Infinity;
          slides.forEach(function (s, i) {
            var r = s.getBoundingClientRect();
            var sx = r.left + r.width / 2;
            var d = Math.abs(sx - centerX);
            if (d < bestDist) { bestDist = d; bestIdx = i; }
          });
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === bestIdx); });
          if (thumbs[bestIdx]) syncThumbScroll(thumbs[bestIdx]);
        }, 80);
      }, { passive: true });
    }

    /* ---------- Accordions ---------- */
    $$('.bpdp-accordion__header').forEach(function (h) {
      h.addEventListener('click', function () {
        h.parentElement.classList.toggle('is-open');
      });
    });
    // "What's my size?" / "Size guide" anchor links: find the size guide accordion, open + scroll
    $$('a[href="#bpdp-size-guide"]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        var sg = document.getElementById('bpdp-size-guide');
        if (!sg) {
          // Fallback: find by heading match
          sg = $$('.bpdp-accordion').find(function (acc) {
            var h = acc.querySelector('.bpdp-accordion__header');
            return h && /size\s*guide/i.test(h.textContent || '');
          });
        }
        if (sg) {
          sg.classList.add('is-open');
          sg.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    /* ---------- Sticky ATC: scroll-triggered visibility + AJAX submit + drawer ---------- */
    var stickyWrap = $('[data-bpdp-sticky-atc]') || $('.bpdp-sticky-atc');
    if (stickyWrap) {
      // Start hidden — class is removed once user scrolls past the main ATC
      stickyWrap.classList.add('is-hidden');
      var mainAtc = $('[data-bpdp-atc]');
      function updateStickyVisibility() {
        if (!mainAtc) return;
        var rect = mainAtc.getBoundingClientRect();
        // Show only when the bottom of the main ATC has scrolled OFF the top of the viewport
        var pastMain = rect.bottom < 0;
        stickyWrap.classList.toggle('is-hidden', !pastMain);
      }
      updateStickyVisibility();
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility);

      // Click on sticky → run the same submit path as the main ATC
      var stickyBtn = stickyWrap.querySelector('button, a') || stickyWrap;
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        performSubmit(null);
      });
    }
  }

  /* ============================================================
   * Live cart count sync — header [data-bra-cart-count] / [data-bpdp-cart-count]
   * Hooks fetch + XHR + cart events + visibility + poll fallback.
   * ============================================================ */
  function updateAllCartCounters() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-bra-cart-count],[data-bpdp-cart-count]').forEach(function (el) {
          if (el.textContent !== String(cart.item_count)) {
            el.textContent = cart.item_count;
            var parent = el.closest('[data-bra-cart-link],[data-bpdp-cart-link]');
            if (parent) {
              parent.classList.add('is-cart-pulse');
              setTimeout(function () { parent.classList.remove('is-cart-pulse'); }, 400);
            }
          }
        });
      })
      .catch(function () {});
  }

  // 1) Hook fetch
  if (window.fetch) {
    var _origFetch = window.fetch;
    window.fetch = function (url, opts) {
      var p = _origFetch.apply(this, arguments);
      try {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(u)) {
          p.then(function () { setTimeout(updateAllCartCounters, 60); });
        }
      } catch (e) {}
      return p;
    };
  }
  // 2) Hook XHR
  if (window.XMLHttpRequest) {
    var _origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__bpdpCartHook = /\/cart\/(add|change|update|clear)(\.js)?/i.test(url || '');
      return _origOpen.apply(this, arguments);
    };
    var _origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__bpdpCartHook) {
        xhr.addEventListener('load', function () { setTimeout(updateAllCartCounters, 60); });
      }
      return _origSend.apply(this, arguments);
    };
  }
  // 3) Listen to common cart events on both document and window
  var cartEvents = ['cart:refresh','cart:updated','cart:added','cart:open','cart-update','on:cart-update','upcart:open','upcart:cart-updated','bold-cart:updated','rebuy:cart-updated','cart:change'];
  cartEvents.forEach(function (n) {
    document.addEventListener(n, updateAllCartCounters);
    window.addEventListener(n, updateAllCartCounters);
  });
  // 4) Visibility change
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) updateAllCartCounters();
  });
  // 5) Poll fallback every 4s while visible
  setInterval(function () { if (!document.hidden) updateAllCartCounters(); }, 4000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      updateAllCartCounters();
    });
  } else {
    init();
    updateAllCartCounters();
  }
})();
